import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeProvider';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Señal para procesos de prerender/SSG (no afecta al runtime normal)
try {
  const trigger = () => document.dispatchEvent(new Event('prerender-ready'));
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(trigger);
  } else {
    setTimeout(trigger, 0);
  }
} catch {
  // ignore
}
